import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── PeopleIQ ───────────────────────────────────────────────────────────────────
// Persona: VP Sales / HR
// Data sources: See constants/modules.js

const KPIs = [
  { label: "Sales Headcount", value: "48 reps", delta: "+6 YTD", color: "#059669" },
  { label: "Avg Ramp Time", value: "90 days", delta: "-14 days YoY", color: "#059669" },
  { label: "Quota Attainment", value: "87%", delta: "Team avg", color: "#d97706" },
  { label: "Attrition Rate", value: "12%", delta: "LTM", color: "#d97706" },
  { label: "Open Roles", value: "8", delta: "Approved to hire", color: "#d97706" },
  { label: "Capacity vs Plan", value: "82%", delta: "-18pts", color: "#e11d48" }
];
const CHART_DATA = [
  {
    "band": ">125%",
    "reps": 8
  },
  {
    "band": "100-125%",
    "reps": 14
  },
  {
    "band": "75-100%",
    "reps": 11
  },
  {
    "band": "50-75%",
    "reps": 9
  },
  {
    "band": "<50%",
    "reps": 6
  }
];

export default function PeopleIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>Quota Attainment Distribution</p>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={CHART_DATA} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="band" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          
          <Bar dataKey="reps" fill="#0d9488" radius={[4,4,0,0]} />
        </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>6 reps below 50% attainment for 2+ consecutive quarters — performance management action needed. Top quartile (8 reps) are hitting 130%+ avg.</p>
        </div>
      </div>
    </div>
  );
}
